import React from 'react';
import { DialogActions } from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import Dropzone from 'react-dropzone';
import { MdClear, MdCloudUpload, MdInsertDriveFile } from 'react-icons/md';

import Snackbar from 'material-ui/Snackbar';
import './index.css';
import axios from 'axios';
import { withStyles } from 'material-ui/styles';
import { isImage } from './helpers/helpers.js';
import { connect } from 'react-redux';
import { setUserAction } from 'entoro-shared';
import { withApollo } from 'react-apollo';
import { RESTAPI_URI } from '../../config';
import { CircularProgress } from 'material-ui';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const styles = (theme) => ({
  dialogPaper: {
    padding: '55px',
  },
  button: {
    margin: '30px',
  },
  dialog: {
    position: 'relative',
    top: '30px',
  },
});

class AcuantFileUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openSnackBar: false,
      errorMessage: '',
      files: this.props.files || [],
      disabled: true,
      submitting: false,
      acceptedFiles: [
        'image/jpeg',
        'image/png',
        'image/bmp',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ],
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      open: nextProps.open,
      files: nextProps.files,
    });
  }

  handleClose() {
    this.closeDialog();
    this.setState({ open: false });
  }

  onDrop(files) {
    let oldFiles = this.state.files;
    const filesLimit = '1';

    oldFiles = oldFiles.concat(files);

    if (oldFiles.length > filesLimit) {
      this.setState({
        openSnackBar: true,
        errorMessage: 'Cannot upload more then ' + filesLimit + ' items.',
      });
    } else {
      this.setState(
        {
          files: oldFiles,
        },
        this.changeButtonDisable
      );
    }
  }

  handleRemove(file, fileIndex) {
    const files = this.state.files;
    // This is to prevent memory leaks.
    window.URL.revokeObjectURL(file.preview);

    files.splice(fileIndex, 1);
    this.setState(files, this.changeButtonDisable);

    if (file.path) {
      this.props.deleteFile(file);
    }
  }

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    const { files } = this.state;
    const { dispatch } = this.props;
    for (let i = files.length; i >= 0; i--) {
      const file = files[0];
      if (file) {
        URL.revokeObjectURL(file.preview);
      }
    }
    dispatch(setUserAction({ showDocxForm: false }));
  }
  changeButtonDisable() {
    if (this.state.files.length !== 0) {
      this.setState({
        disabled: false,
      });
    } else {
      this.setState({
        disabled: true,
      });
    }
  }

  saveFiles() {
    const filesLimit = '1';

    if (this.state.files.length > filesLimit) {
      this.setState({
        openSnackBar: true,
        errorMessage: 'Cannot upload more then ' + filesLimit + ' items.',
      });
    } else {
      this.props.saveFiles(this.state.files);
    }
  }

  onDropRejected() {
    this.setState({
      openSnackBar: true,
      errorMessage: 'File too big, max size is 5MB',
    });
  }

  handleRequestCloseSnackBar = () => {
    this.setState({
      openSnackBar: false,
    });
  };

  handleEmptyInput = () => {
    this.setState({
      openSnackBar: true,
      errorMessage: 'Please Upload a File (document or image)',
    });
  };
  handlePostSubmit(e) {
    e.preventDefault();

    this.setState({ submitting: true });

    const { investorUser, dispatch, handleClose } = this.props;

    const { appId, kycAppId, _id: userId, tenantId } = investorUser;
    const config = { headers: { 'Content-Type': 'application/json' } };

    let fd = new FormData();
    let applicationId = kycAppId || appId;
    fd.append('file', this.state.files[0]);
    fd.append('investorKycId', applicationId);
    fd.append('userId', userId);
    fd.append('tenantId', tenantId);
    axios
      .post(`${RESTAPI_URI}/performinvestorkycdocumentupload`, fd, config)
      .then((response) => {
        handleClose();
        dispatch(
          setUserAction({
            hasUploadedKycDocx: true,
          })
        );
        const MySwal = withReactContent(Swal);
        const Toast = MySwal.mixin({
          toast: true,
          position: 'bottom-right',
          showConfirmButton: false,
          timer: 8000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', MySwal.stopTimer);
            toast.addEventListener('mouseleave', MySwal.resumeTimer);
          },
        });
        Toast.fire({
          icon: 'success',
          title:
            'Your Document Verification Request requires further review, we will be in touch shortly.',
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    let img;
    let previews = '';
    const fileSizeLimit = 5000000;
    const { handleClose, classes } = this.props;
    const { submitting, files } = this.state;
    previews = this.state.files.map((file, i) => {
      const path = URL.createObjectURL(file);

      if (isImage(file)) {
        //show image preview.
        img = <img className='smallPreviewImg' src={path} />;
      } else {
        //Show default file image in preview.
        img = <MdInsertDriveFile className='smallPreviewImg' />;
      }

      return (
        <div>
          <div className={'imageContainer col fileIconImg'} key={i}>
            {img}
            <div className='middle'>
              <MdClear
                className='removeBtn'
                onClick={this.handleRemove.bind(this, file, i)}
              />
            </div>
          </div>
        </div>
      );
    });

    return (
      <div>
        <Dropzone
          accept={this.state.acceptedFiles.join(',')}
          onDrop={this.onDrop.bind(this)}
          className={'dropZone'}
          acceptClassName={'stripes'}
          rejectClassName={'rejectStripes'}
          onDropRejected={this.onDropRejected.bind(this)}
          maxSize={fileSizeLimit}
        >
          <div className={'dropzoneTextStyle'}>
            <MdCloudUpload className={'uploadIconSize'} />
            <p className={'dropzoneParagraph'}>
              {'Drag and drop a file here or click'}
            </p>
            <span>{'Max. File Size is 5MB'}</span>
          </div>
        </Dropzone>

        <br />
        <div className='row'>
          {this.state.files.length ? <span>Preview:</span> : ''}
        </div>
        <div className='row'>{previews}</div>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.errorMessage}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestCloseSnackBar}
        />
        <DialogActions
          classes={{
            root: classes.dialog,
          }}
        >
          <Button
            disabled={submitting}
            onClick={handleClose}
            className='action-button cancel'
            disableRipple
          >
            Cancel
          </Button>
          {this.state.files.length ? (
            <Button
              disabled={submitting}
              onClick={this.handlePostSubmit.bind(this)}
              className='action-button'
              disableRipple
            >
              {submitting ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CircularProgress size={15} color='inherit' />
                  &nbsp;
                  {'Submit'}
                </div>
              ) : (
                'Submit'
              )}
            </Button>
          ) : (
            <Button
              onClick={this.handleEmptyInput.bind(this)}
              className='action-button'
              disableRipple
            >
              {'Submit'}
            </Button>
          )}
        </DialogActions>
      </div>
    );
  }
}
const mapStateToProps = ({ investorUser, tenant }) => ({
  investorUser,
  tenant,
});
export default connect(mapStateToProps)(
  withStyles(styles)(withApollo(AcuantFileUpload))
);



// WEBPACK FOOTER //
// ./src/components/AcuantFileUploader/index.js